import { push } from 'connected-react-router'

import {
  clearSession,
  RELOAD_SUCCESS,
  UNCONFIRMED_USER_SIGNIN,
  SIGNIN_SUCCESS
} from '../reducers/currentUser'

export const handleUnconfirmedUsers = ({ dispatch, getState }) => {
  return (next) => (action) => {
    if (action.type === RELOAD_SUCCESS || action.type === SIGNIN_SUCCESS) {
      if (!action.payload.data.confirmed_at) {
        clearSession()
        dispatch(push('/confirmation/new'))
        dispatch({ type: UNCONFIRMED_USER_SIGNIN })
        return
      }
    }
    return next(action)
  }
}
